import React, { Component } from 'react'
import { Avatar, Card, Typography, Row, Col } from 'antd'
import Config from '../../../../config'
import PetProfileImage from '../../../../assets/images/pet-profile-pic.svg'
import { AdoptionApplicationProps } from '..'

export default class Information extends Component<AdoptionApplicationProps> {
  render() {
    const { data } = this.props
    const adopter = data?.adopter_user
    const pet = data?.pet
    const branch = pet?.branch
    const checkout = data?.checkout

    const shelterLogo = (
      <Avatar
        size={64}
        src={branch?.shelter ? `${Config.cdnImagesBase}organization/shelter/logo/AUTOx64/${branch.shelter.logo}` : ''}
      />
    )

    const shelterInfo = (
      <>
        <Typography.Text strong>Location: </Typography.Text>
        <Typography.Text>{branch?.name}</Typography.Text>
      </>
    )

    const adopterAvatar = (
      <Avatar size={64} style={{ backgroundColor: '#e52e6b', verticalAlign: 'middle' }}>
        {adopter?.first_name.slice(0, 1).toUpperCase()}
      </Avatar>
    )

    const adopterInfo = (
      <>
        <Typography.Text strong>Email: </Typography.Text>
        <Typography.Text>{adopter?.email}</Typography.Text>
      </>
    )

    const petAvatar = (
      <Avatar
        size={64}
        src={pet?.picture ? `${Config.cdnImagesBase}organization/pet/picture/AUTOx64/${pet.picture}` : PetProfileImage}
      />
    )

    const petInfo = (
      <>
        <div>
          <Typography.Text strong>Specie: </Typography.Text>
          <Typography.Text>{pet?.specie?.name}</Typography.Text>
        </div>
        {
          pet?.custom_code ? (
            <div>
              <Typography.Text strong>Custom Code: </Typography.Text>
              <Typography.Text>{pet?.custom_code}</Typography.Text>
            </div>
          ) : null
        }
        {
          !pet?.custom_code && pet?.global_code ? (
            <div>
              <Typography.Text strong>Global Code: </Typography.Text>
              <Typography.Text>{pet?.global_code}</Typography.Text>
            </div>
          ) : null
        }
      </>
    )

    const checkoutInfo = (
      <>
        {
          checkout?.map((checkout, index) => (
            <div key={`checkout-info-${index}`}>
              <Typography.Text strong>{checkout.type_key}: </Typography.Text>
              <Typography.Text>{checkout.price}</Typography.Text>
            </div>
          ))
        }
      </>
    )

    return (
      <Row gutter={12} justify="space-between">
        <Col>
          <Card title="Shelter" style={{width: 380}}>
            <Card.Meta
              avatar={shelterLogo}
              title={branch?.shelter?.name}
              description={shelterInfo}
            />
          </Card>
        </Col>

        <Col>
          <Card title="Adopter" style={{width: 380}}>
            <Card.Meta
              avatar={adopterAvatar}
              title={adopter?.first_name.concat(' ', adopter?.last_name)}
              description={adopterInfo}
            />
          </Card>
        </Col>

        <Col>
          <Card title="Pet" style={{width: 380}}>
            <Card.Meta
              avatar={petAvatar}
              title={pet?.name}
              description={petInfo}
            />
          </Card>
        </Col>

        <Col>
          <Card title="Checkout" style={{width: 380 , height: "100%"}}>
            <Card.Meta
              description={checkoutInfo}
            />
          </Card>
        </Col>
      </Row>
    )
  }
}
